import {create} from 'zustand';
import {persist} from 'zustand/middleware';
// Default Configuration Constants
const DEFAULT_PAGE_ORIENTATION = 'portrait';
const DEFAULT_PAGE_MARGINS = {
  top: 0.5,
  right: 0.5,
  bottom: 0.5,
  left: 0.5
};
const DEFAULT_LINE_SPACING = 1.5;
const DEFAULT_BLOCK_SIZE = {
  width: 400,
  height: 150
};
const DEFAULT_WATERMARK = {
  text: '',
  color: '#cccccc',
  fontSize: 60,
  opacity: 0.5,
  layout: 'diagonal' as const,
  fontFamily: 'Arial'
};
const DEFAULT_LAYOUT_CONSTRAINTS = {
  MIN_CONTENT_WIDTH_IN: 2,
  MIN_CONTENT_HEIGHT_IN: 2
};
const DEFAULT_SPACING = {
  paragraph: 10,
  header: 16,
  footer: 10
};

const PLACEHOLDER_TYPES: Record<string, any> = {
  logo: {label: 'Logo', color: '#e8f0fe', text: 'Logo', shape: 'square'},
  banner: {
    label: 'Banner',
    color: '#f0f4f7',
    text: 'Banner',
    shape: 'rectangle'
  },
  hero: {
    label: 'Hero Image',
    color: '#ffe8f0',
    text: 'Hero Image',
    shape: 'rectangle'
  },
  icon: {label: 'Icon', color: '#e8fff0', text: 'Icon', shape: 'square'},
  thumbnail: {
    label: 'Thumbnail',
    color: '#fff8e8',
    text: 'Thumbnail',
    shape: 'rectangle'
  },
  circle: {
    label: 'Circle',
    color: '#e8f0fe',
    text: 'Logo (circle)',
    shape: 'circle'
  },
  spacer: {
    label: 'Spacer',
    color: '#f8f9fa',
    text: 'Spacer',
    shape: 'rectangle'
  }
};

export interface ConfigState {
  pageOrientation: 'portrait' | 'landscape';
  pageMargins: {top: number; right: number; bottom: number; left: number};
  lineSpacing: number;
  blockSize: {width: number; height: number};
  watermark: typeof DEFAULT_WATERMARK;
  layoutConstraints: {
    MIN_CONTENT_WIDTH_IN: number;
    MIN_CONTENT_HEIGHT_IN: number;
  };
  spacing: {paragraph: number; header: number; footer: number};
  placeholderTypes: typeof PLACEHOLDER_TYPES;
}

export interface ConfigActions {
  updateConfig: (config: Partial<ConfigState>) => void;
  resetToDefaults: () => void;
}

const initialConfig: ConfigState = {
  pageOrientation: DEFAULT_PAGE_ORIENTATION,
  pageMargins: DEFAULT_PAGE_MARGINS,
  lineSpacing: DEFAULT_LINE_SPACING,
  blockSize: DEFAULT_BLOCK_SIZE,
  watermark: DEFAULT_WATERMARK,
  layoutConstraints: DEFAULT_LAYOUT_CONSTRAINTS,
  spacing: DEFAULT_SPACING,
  placeholderTypes: PLACEHOLDER_TYPES
};

export const useConfigStore = create<ConfigState & ConfigActions>()(
  persist(
    (set) => ({
      ...initialConfig,

      updateConfig: (config) => {
        set((state) => ({...state, ...config}));
      },
      resetToDefaults: () => {
        set(initialConfig);
      }
    }),
    {
      name: 'app-config'
    }
  )
);
